<template>
  <div class="card ">
    <div class="card-header p-2">
      <ul class="nav nav-pills">
        <li class="nav-item"><a class="nav-link" href="#activity" data-toggle="tab" v-bind:class="activetab == 1 ? 'active': 'disabled'">1. Admission Details</a></li>
        <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-bind:class="activetab == 2 ? 'active': 'disabled'">2. Personal Information</a></li>
        <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-bind:class="activetab == 3 ? 'active': 'disabled'">3. Education Background</a></li>
        <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-bind:class="activetab == 4 ? 'active': 'disabled'">4. Documents</a></li>
      </ul>
    </div>
    <!--<div class="card-header with-border">
      <h3 class="card-title" style="width: 100%">
        Student Registration
        <span style="color: red; font-weight: bolder" v-if="st.StudentRegistrationID != '0'">| Roll No: {{st.RollNo}}</span>
        <blink class="pull-right" style="color: red; font-weight: bolder; font-size: 19px;">Note: All * fields are mendatory</blink>
      </h3>
    </div>-->
    <!-- /.box-header -->
    <!-- form start -->
    <form v-on:submit="save">
      <div class="card-body" style="padding-left: 1%; padding-right: 1%; padding-top: 1%">
        <div class="nav-tabs-custom">
          <!--<ul class="nav nav-tabs" style="width: 100%">
          <li v-bind:class="activetab == 1 ? 'active': 'disabled'"><a>1. Admission Details</a></li>
          <li v-bind:class="activetab == 2 ? 'active': 'disabled'"><a>2. Personal Information</a></li>
          <li v-bind:class="activetab == 3 ? 'active': 'disabled'"><a>3. Education Background</a></li>
          <li v-bind:class="activetab == 4 ? 'active': 'disabled'"><a>4. Attachments</a></li>
        </ul>-->
          <div class="tab-content">
            <div class="tab-pane active">
              <div v-if="activetab == 1">
                <div class="row">
                  <div class="col-md-10 col-sm-12">
                    <div class="row">
                      <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                        <label>
                          Form No
                        </label>
                        <input type="text" v-bind:disabled="showverified" class="form-control" v-model="st.FormNo" autocomplete="off" placeholder="(written on admission form)" v-mask="'##########'">
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-12">
                        <label>Batch *</label>
                        <select class="form-control" v-model="st.SessionID" v-on:change="loadSection()" required>
                          <option value="" disabled="disabled" selected="selected">-- Select Batch --</option>
                          <option v-for="p in sessions" v-bind:value="p.SessionID">{{p.Name}}</option>
                        </select>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-12">
                        <label>Program *</label>
                        <select class="form-control" v-model="st.ProgramID" v-on:change="loadSection()" required>
                          <option value="" disabled="disabled" selected="selected">-- Select Program --</option>
                          <option v-for="p in programs" v-bind:value="p.ProgramID">{{p.ProgramName}}</option>
                        </select>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-12">
                        <label>Type *</label>
                        <select class="form-control" v-model="st.Type" required>
                          <option value="Regular" selected="selected">Regular</option>
                          <option value="Self-Support">Self-Support</option>
                        </select>
                      </div>
                      <div class="col-lg-4 col-md-6 col-sm-12">
                        <label>Section *</label>
                        <select class="form-control" v-model="st.SectionID" required>
                          <option value="" disabled="disabled" selected="selected">-- Select Section --</option>
                          <option v-for="p in sections" v-bind:value="p.SectionID">{{p.Name}}</option>
                        </select>
                      </div>
                      <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                        <label for="validationCustom01">Student Name *</label>
                        <input type="text" class="form-control" pattern=".{3,}" title="minimum 3 character required" v-model="st.Name" maxlength="50" autocomplete="off" placeholder="Candidate's full name (max 50 characters)" required>
                      </div>
                      <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                        <label for="validationCustom02">Student Mobile No. *</label>
                        <input type="text" class="form-control" v-mask="'###########'" pattern=".{11,11}" title="11 digit required" maxlength="11" placeholder="03001234567" v-model="st.MobileNo" autocomplete="off" required>
                      </div>
                      <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                        <label for="validationCustom02">CNIC/Form B No *</label>
                        <input type="text" class="form-control" v-model="st.CNIC" v-mask="'#############'" pattern=".{13,13}" title="13 digit is required" autocomplete="off" placeholder="_____________" maxlength="13" required>
                      </div>
                      <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                        <label for="validationCustom02">Father Name *</label>
                        <input type="text" class="form-control" v-model="st.FathersName" pattern=".{3,}" title="only alphabet allowed min length is 3" autocomplete="off" maxlength="50" placeholder="Candidate's father name (max 50 characters)" required>
                      </div>
                      <!--<%--<div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom02">Old Roll No.</label>
                      <input type="text" class="form-control" v-model="st.OldRollNo" onkeypress="return allowOnlyNumber(event);" autocomplete="off" maxlength="13">
                    </div>--%>-->
                      <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                        <label for="validationCustom02">Registration No.</label>
                        <input type="text" class="form-control" v-model="st.RegistrationNo" pattern=".{3,}"  title="only alphabet allowed min length is 3" autocomplete="off" maxlength="50" placeholder="Issued by Institute">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-4 col-xga-4 col-xs-4">
                    <img v-bind:src="image" class="img-thumbnail" />
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" v-on:change="onfileupload" id="validatedCustomIconLabel" />
                      <!--<input type="file" class="custom-file-input" v-on:change="onfileupload" id="validatedCustomIconLabel"--> <!--<%--v-bind:required="getImgReq()"--%>--> <!--/>-->
                      <button class="btn btn-default btn-sm" v-if="image != '../Images/icon-profile.png'" type="button" style="width: 100%" v-on:click="removePicture()">Remove</button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="activetab == 2">
                <div class="row">
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Student Name *</label>
                    <input type="text" class="form-control" id="validationCustom01" v-model="st.Name" pattern=".{3,}" title="only alphabets allowed min length is 3" maxlength="50" autocomplete="off" placeholder="Candidate's full name (max 50 characters)" required>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Gender *</label>
                    <select style="width: 100%" class="form-control" id="ddlGender" v-model="st.GenderID" required>
                      <option value="" disabled="disabled" selected="selected">-- Select Gender --</option>
                      <option v-for="item in genders" v-bind:value="item.GenderID">{{item.Name}}</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">CNIC/Form B No *</label>
                    <input type="text" class="form-control" v-model="st.CNIC" v-mask="'#############'" pattern=".{13,13}" title="13 digit is required" autocomplete="off" placeholder="_____________" maxlength="13" required>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Father Name *</label>
                    <input type="text" class="form-control" v-model="st.FathersName" pattern=".{3,}" title="only alphabet allowed min length is 3" autocomplete="off" maxlength="50" placeholder="Candidate's father name (max 50 characters)" required>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Father CNIC No</label>
                    <input type="text" class="form-control" v-model="st.FatherCNIC" v-mask="'#############'" pattern=".{13,13}" maxlength="13" title="13 digit required" autocomplete="off" placeholder="_____________">
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Father/Guardian Mobile *</label>
                    <input type="text" class="form-control" v-model="st.FatherMobileNo" pattern=".{11,11}" v-mask="'###########'" maxlength="11" title="11 digit required" autocomplete="off" placeholder="_____________" required>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Date of Birth *</label>
                    <input type="date" class="form-control" placeholder="dd/MM/YYYY" v-model="st.DateOfBirth" autocomplete="off" required>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Domicile *</label>
                    <select style="width: 100%" class="form-control" v-model="st.DomicileID" required>
                      <option value="" disabled="disabled" selected="selected">-- Select Domicile --</option>
                      <option v-for="item in cities" v-bind:value="item.CityID">{{item.Name}}</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">City *</label>
                    <select style="width: 100%" class="form-control" v-model="st.CityID">
                      <option value="" disabled="disabled" selected="selected">-- Select City --</option>
                      <option v-for="item in cities" v-bind:value="item.CityID">{{item.Name}}</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">District *</label>
                    <input style="width: 100%" class="form-control" v-model="st.District" required />
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Tehsil *</label>
                    <input style="width: 100%" class="form-control" v-model="st.Tehsil" required />
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Permanent Address *</label>
                    <input type="text" class="form-control " maxlength="150" v-model="st.Address" placeholder="House #: 00, Street #: 00, Area Name (max 150 characters)" autocomplete="off" required>
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Postal Address/ Postal Code</label>
                    <input type="text" class="form-control" maxlength="150" v-model="st.PostalAddress" placeholder="(max 150 characters)" autocomplete="off">
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Applicant Mobile *</label>
                    <input type="text" class="form-control" v-mask="'###########'" pattern=".{11,11}" title="11 digit required" maxlength="11" placeholder="03001234567" v-model="st.MobileNo" autocomplete="off" required>
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Land Line (along with area code)</label>
                    <input type="text" class="form-control" maxlength="11" placeholder="04230000000" v-model="st.LandLineNo" autocomplete="off">
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Email *</label>
                    <input type="email" class="form-control" placeholder="Candidate's email address" v-model="st.Email" maxlength="50" autocomplete="off" required>
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Religion</label>
                    <select style="width: 100%" class="form-control" v-model="st.ReligionID">
                      <option value="" disabled="disabled" selected="selected">-- Select Religion --</option>
                      <option v-for="item in religions" v-bind:value="item.ReligionID">{{item.Name}}</option>
                    </select>
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Blood Group</label>
                    <select style="width: 100%" class="form-control" v-model="st.BloodGroup">
                      <option value="" disabled="disabled" selected="selected">-- Select Blood Group --</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="N/A">N/A</option>
                    </select>
                  </div>

                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom02">Hafiz-e-Quran *</label>
                    <select style="width: 100%" class="form-control" v-model="st.Hafiz">
                      <option value="false" selected="selected">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Disability</label>
                    <select style="width: 100%" class="form-control" v-model="st.Disability">
                      <option value="false" selected>No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3" v-if="st.Disability == true" v-on:change="disabilityChange()">
                    <label for="validationCustom01">Disability Type*</label>
                    <input maxlength="150" style="width: 100%" class="form-control" v-model="st.DisabilityType" required />
                  </div>
                  <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                    <label for="validationCustom01">Hostel Required</label>
                    <select style="width: 100%" class="form-control" v-model="st.HostelRequired">
                      <option value="false" selected>No</option>
                      <option value="true">Yes</option>
                    </select>
                  </div>
                </div>
                
              </div>
              <div v-if="activetab == 3">
                <div class="table-responsive ">
                  <table class="table table-color table-bordered table-sm">
                    <thead class="bg-info">
                      <tr>
                        <th style="width: 13%">Education Level</th>
                        <th style="width: 75px">Type</th>
                        <th style="width: 13%">Degree</th>
                        <th style="width: 75px">Passing Year</th>
                        <th style="width: 10%">Roll No</th>
                        <th style="width: 15%">Board/Institute</th>
                        <th style="width: 75px">Tot. Marks</th>
                        <th style="width: 75px">Obt. Marks</th>
                        <th style="width: 79px">Grade</th>
                        <th style="width: 13%">Major Subject</th>
                        <th style="width: 75px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in education">

                        <td>
                          <select class="form-control" v-model="item.EducationLevelID" required>
                            <option value="">-- Select --</option>
                            <option v-for="item in edulevels" v-bind:value="item.AggregateTypeID">{{item.Name}}</option>
                          </select>
                        </td>

                        <td style="text-align: center; vertical-align: middle">
                          <select class="form-control" v-bind:required="!item.Optional" v-model="item.Type" v-bind:disabled="item.EducationLevelID < 3" v-if="item.EducationLevelID < 12">
                            <option value="Annual">Annual</option>
                            <option value="Semester" v-f="item.EducationLevelID > 2">Semester</option>
                          </select>

                          <span v-else>--</span>
                        </td>

                        <td>
                          <input class="form-control" placeholder="e.g. ICS" maxlength="40" style="height: 32px !important" required v-model="item.DegreeName" />
                        </td>
                        <td>
                          <input aria-multiline="true" class="form-control" placeholder="2013" v-on:change="passingYearChange(index)" onkeypress="return allowOnlyNumber(event);" pattern=".{4,4}" maxlength="4" style="height: 32px !important" required v-model="item.PassingYear" />
                        </td>
                        <td>
                          <input class="form-control number" placeholder="2151099" maxlength="15" style="height: 32px !important" required v-model="item.RollNo" />
                        </td>
                        <td>
                          <input class="form-control" maxlength="40" placeholder="Lahore Board" style="height: 32px !important" required v-model="item.InstituteName" />
                        </td>
                        <td style="width: 75px">
                          <input class="form-control" style="height: 32px !important" required onkeypress="return allowOnlyNumberandPeriod(event);" maxlength="4" placeholder="1100" v-model="item.TotalMarks" v-on:keyup="marksChange(item)" />
                        </td>
                        <td>
                          <input class="form-control" style="height: 32px !important" required onkeypress="return allowOnlyNumberandPeriod(event);" maxlength="4" placeholder="900" v-model="item.ObtainedMarks" v-on:keyup="marksChange(item)" />
                        </td>

                        <td style="text-align: center; vertical-align: middle">
                          <select v-if="item.EducationLevelID < 12" class="form-control" v-model="item.Division">
                            <option value="">-Select-</option>
                            <option value="A+">A+</option>
                            <option value="A">A</option>
                            <option value="B+">B+</option>
                            <option value="B">B</option>
                            <option value="C+">C+</option>
                            <option value="C">C</option>
                            <option value="D">D+</option>
                            <option value="D">D</option>
                          </select>
                          <span v-else>--</span>
                        </td>

                        <td>
                          <input class="form-control" name="major" v-model="item.MajorSubjects" style="height: 32px !important" placeholder="Major Subject" />
                        </td>
                        <td style="text-align: center">
                          <button type="button" style="border: none; background-color: transparent" v-on:click="removeEducation(index)"><i class="fa fa-2x fa-trash"></i></button>
                        </td>

                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="10" style="text-align: center;">
                          <button style="width: 100%" id="btnNewEducation" v-if="education.length < 5" type="button" class="btn btn-default" v-on:click="addEducation()">Add New</button>
                          <label v-if="education.length == 5">Only 6 entries allowed </label>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div v-if="activetab == 4">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-borderless table-color">
                      <thead>
                        <tr>
                          <th style="width: 50%">Description</th>
                          <th style="width: 40%">Upload File</th>
                          <th style="width: 10px; text-align: center">Action</th>
                        </tr>
                      </thead>
                      <tbody>

                        <tr v-for="(item, ind) in documents">
                          <td>
                            <input maxlength="30" v-model="item.Description" class="form-control" required />
                          </td>
                          <td>
                            <input type="file" v-on:change="documentUpload(ind)" class="form-control" />
                          </td>
                          <td style="text-align: center;">
                            <a href="#" v-on:click="removeDocument(ind)"><i style="color: black" class="fa fa-2x fa-trash"></i></a>
                            <a download="attachment.png" v-if="item.base64string != ''" v-bind:href="item.base64string"><i class="fa fa-download fa-2x"></i></a>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" style="text-align: center;">
                            <button style="width: 100%" type="button" class="btn btn-default" v-if="documents.length < 4" v-on:click="addFile()">Add New</button>
                            <label v-if="documents.length == 4">Only 4 attachemnts are allowed </label>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.tab-content -->
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-md-10">
            <button type="button" class="btn btn-danger pull-left" id="Button1" v-on:click="backToRecord()">Back To Record</button>
          </div>

          <div class="col-md-2">
            <div class="pull-right">
              <button type="button" class="btn btn-primary " v-if="activetab > 1" style="margin-right: 5px" v-on:click="back()">Back</button>

              <button type="submit" v-if="activetab < 4" class="btn btn-success" id="Button2">Next</button>
              <button type="submit" v-if="activetab == 4" class="btn btn-success ">Save</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        activetab: 1,
        errors: [],
        religions: [],
        nationalities: [],
        genders: [],
        countries: [],
        categories: [],
        sessions: [],
        sections: [],
        cities: [],
        cnic: '',
        programs: [],
        minage: 0,
        maxage: 0,
        domiciles: [],
        isvalidate: true,
        showverified: false,
        showunverified: false,
        image: '../Images/icon-profile.png',
        activesemester: '',
        isupdate: false,
        allowedchoices: '',
        edulevels: [],
        isconfirmed: false,
        st: {
          StudentRegistrationID: 0,
          OldRollNo: 0,
          RegistrationNo: '',
          FormNo: '',
          District: '',
          Tehsil:'',
          //Name: '',
          GenderID: 0,
          CNIC: '',
          DegreeID: '',
          FathersName: '', 
          Disability: 'false',
          DisabilityType: null, 
          FatherCNIC: '',
          FatherMobileNo: '',
          CityID: 0,
          CountryID: 1,
          Hafiz: 'false',
          NationalityID: 1,
          ReligionID: 0,
          MobileNo: '',
          LandLineNo: '',
          Address: '',
          PostalAddress: '',
          DateOfBirth: '',
          DomicileID: 0,
          //Email: '',
          BloodGroup: '',
          HostelRequired: false,
          ProgramID: '',
          SessionID: '',
          SectionID: '',
          Type: 'Regular',
          AdmissionCategoryID: '',
          IsOnline: 'true',
          Remarks: '',
          RelativeRelation: '',
          RelativeMobileNo: '',
          RelativeName: ''
        },
        education: [],
        documents: [],
        choices: [],
      }
    },
    created: function () {
    },

    mounted: function () {
      this.pageLoad();
      this.pageUpdate();
    },
    methods: {

      pageLoad: function () {

      
        var vm = this;
        
          //startReq();
          axios.post('/api/StudentsApi/pageLoad')
            .then(function (pl) {
              vm.nationalities = pl.data["nat"];
              vm.cities = pl.data["cit"];
              vm.religions = pl.data["rel"];
              vm.programs = pl.data["pro"];
              vm.sessions = pl.data["ses"];
              vm.countries = pl.data["cou"];
              vm.genders = pl.data["gen"];
              vm.domiciles = pl.data["cit"];
              vm.edulevels = pl.data["agg"];
             
              
            })
        
      },
      disabilityChange() {
        if (!this.st.Disability) {
          this.st.DisabilityType = null;
        }
      },
      pageUpdate() {
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const stID = params.get('id');
        if (vm.stID != 'null') {
          axios.post('/api/StudentsApi/checkUpdate?id=' + stID)
            .then(function (up) {
              if (up.data.status) {
                vm.st = up.data.st;
                var secID = vm.st.SectionID;
                vm.education = up.data.edu;
                axios.post('/api/StudentsApi/loadSections?progID=' + vm.st.ProgramID + "&sesID=" + vm.st.SessionID)
                  .then(function (de) {
                    vm.sections = de.data.lst;
                    vm.st.SectionID = secID;
                    vm.isupdate = true;
                    if (vm.st.temp != "") {
                      vm.image = vm.st.temp;
                    }
                    endReq();
                  })
                  .catch(function (error) {
                    console.log(error);
                  })
              }
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            })
        }
      },

      loadSection: function () {
        var vm = this;
        startReq();
        if (vm.st.ProgramID != null && vm.st.SessionID != null && vm.st.ProgramID != '' && vm.st.SessionID != '') {
          axios.post('/api/StudentsApi/loadSections?progID=' + vm.st.ProgramID + "&sesID=" + vm.st.SessionID)
            .then(function (de) {
              vm.sections = de.data.lst;
              endReq();
            })
            .catch(function (error) {
              console.log(error);
            })
        }
        else {
          endReq();
        }
      },

      btnContinue() {
        $('#myModal').modal('hide');
        this.isconfirmed = true;
      },

      checkFile(file) {
        if (file == null) {
          return false;
        }

        if (file.size > 200000) {
          toastr.error("file size is large max size is 200 kb", "Error!");
          return false;
        }

        if (file.type != "image/jpeg" && file.type != "image/png") {
          toastr.error("Invalid File! png/jpeg format is allowed");
          return false;
        }

        return true;
      },

      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.image = e.target.result;
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
      },

      removePicture() {
        this.image = '../Images/icon-profile.png';
      },

      save: function (e) {
        e.preventDefault();
        var vm = this;
        vm.ischeck = false;
        vm.st.Active = true;
        vm.st.Status = 'Normal';


        if (this.activetab == 1 && (this.st.CityID == 0 || this.st.CityID == '')) {
          this.st.GenderID = 0;
          this.st.FatherCNIC = '';
          this.st.FatherMobileNo = '';
          this.st.CityID = 0;
          this.st.CountryID = 1;
          this.st.Hafiz = 'false';
          this.st.NationalityID = 1;
          this.st.ReligionID = 0;
          this.st.LandLineNo = '';
          this.st.Address = '';
          this.st.PostalAddress = '';
          this.st.DateOfBirth = '';
          this.st.DomicileID = 0;
          this.st.Remarks = '';
        }

        if (this.st.OldRollNo == null || this.st.OldRollNo == "") {
          this.st.OldRollNo = 0;
        }

        if (this.st.FormNo == null || this.st.FormNo == "") {
          this.st.FormNo = 0;
        }

        if (this.activetab == 1 || this.activetab == 2) {
          this.education = [];
          this.documents = [];
        }

        if (this.activetab == 2 && (this.st.ReligionID == "" || this.st.ReligionID == null))
          this.st.ReligionID = 0;

        if (this.activetab == 3)
          this.documents = [];

        startReq();

        axios.post('/api/StudentsApi/Save', {
          obj: vm.st,
          tab: vm.activetab,
          img: vm.image,
          education: vm.education,
          documents: vm.documents,
        })
          .then(function (res) {

            var er = res.data["record"];

            if (er.StudentRegistrationID != null && er.StudentRegistrationID != 0) {
              vm.st = er;
              vm.activetab = vm.activetab + 1;
              endReq();
              vm.image = vm.st.temp;
              toastr.success("Saved Successfully", "Done!");
              vm.education = res.data["lstEdu"];
              vm.documents = res.data["lstDoc"];

              if (vm.activetab > 4) {
                setTimeout(myFunction, 1000);
              }

              return true;
            }

            endReq();

            for (var i = 0; i < er.length; i++) {
              toastr.error(er[i], "Error!");
            }
            return false;

          })
          .catch(function (error) {
            console.log(error);
            endReq();
          })
      },

      update() {
        var vm = this;

        startReq();
        axios.post('/api/StudentsApi/Update', {
          obj: vm.st,
          education: vm.education,
          choices: vm.choices,
          img: vm.image
        })
          .then(function (res) {
            var er = res.data;
            endReq();
            if (er == "success") {
              toastr.success("Update Successfully", "Done!");
              return;
            }
            for (var i = 0; i < er.length; i++) {
              toastr.error(er[i], "Error!");
            }
          })
          .catch(function (error) {
            console.log(error);
            endReq();
          })
      },

      getImgReq() {
        return (this.image == '../Images/icon-profile.png' ? true : false);
      },

      next() {
        this.save();
      },

      getStyle(t) {
        if (t < this.activetab) {
          return 'color: #5cb85c; font-weight: bold;';
        }
      },

      back() {
        this.activetab = this.activetab - 1;
      },

      backToRecord() {
        if (!close()) {
          window.location.href = "../Students/Index";
        }
      },

      passingYearChange(i) {
        var d = new Date();
        if (this.education[i].PassingYear > d.getFullYear()) {
          toastr.error("Passing year cannot be greater then current year", "Error!");
          this.education[i].PassingYear = "";
        }
      },

      //Education 

      addEducation() {
        this.education.push({ EducationLevelID: '', Type: 'Annual', Division: '' });
      },

      marksChange(item) {
        //if (this.education[ind].ObtainedMarks != '' && this.education[ind].TotalMarks != '') {
        //    if (Number(this.education[ind].ObtainedMarks) > Number(this.education[ind].TotalMarks)) {

        //        toastr["error"]("Obtained marks cannot be greater then total marks")

        //        this.education[ind].ObtainedMarks = '';
        //        this.education[ind].TotalMarks = '';
        //    }
        //}

        if (item.ObtainedMarks != '' && item.TotalMarks != '') {

          if (item.Type == 'Semester' && item.TotalMarks > 5) {
            toastr.error("Total CGPA cannot be greated then 5");
            item.ObtainedMarks = '';
            item.TotalMarks = '';
            item.Percentage = '0';
            return;
          }

          if (Number(item.ObtainedMarks) > Number(item.TotalMarks)) {

            toastr["error"]("Obtained marks cannot be greater then total marks")

            item.ObtainedMarks = '';
            item.TotalMarks = '';
            item.Percentage = '0';
            return;
          }

          if (item.ObtainedMarks != '' && item.TotalMarks != '') {

            item.Percentage = (Number(item.ObtainedMarks) * 100) / Number(item.TotalMarks);
            return;
          }
        }
        else {

          item.Percentage = '0';
          return;
        }
      },

      removeEducation(ind) {
        this.education.splice(ind, 1);
      },

      //Documents

      addFile() {
        this.documents.push({ base64string: '', Description: '' });
      },

      documentUpload(ind) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.documents[ind].base64string = e.target.result;
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
      },

      removeDocument(ind) {
        this.documents.splice(ind, 1);
      }
    }
  });

  //function allowAlphabet(evt) {
  //  var charCode = (evt.which) ? evt.which : event.keyCode
  //  if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode == 32)
  //    return true;
  //  return false;
  //}

  //function allowOnlyNumberandPeriod(evt) {
  //  var charCode = (evt.which) ? evt.which : event.keyCode
  //  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46)
  //    return false;
  //  return true;
  //}

  //function allowOnlyNumber(evt) {
  //  var charCode = (evt.which) ? evt.which : event.keyCode
  //  if (charCode > 31 && (charCode < 48 || charCode > 57))
  //    return false;
  //  return true;
  //}


  $(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  function myFunction() {
    window.location = '../Students/Create';
  }

</script>



// WEBPACK FOOTER //
// src/components/DC/studentRegistration.vue